import { Injectable } from '@angular/core';
import { RequestsServices } from './requests.service';

@Injectable()
export class CompanyService {

    constructor(
        private request: RequestsServices
    ) { }

    listCompaniesByLocation(params): any {
        return this.request.get({ path: 'companies', endPoint: 'exploreLocation', params });
    }
}
